import React, { useEffect, useState } from "react";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import AnalyticsChart from "../analytics/index";

const WidgetObligations = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeKpi, setActiveKpi] = useState("AdempimentiRiepilogoTotale");

  const handleTabChange = e => {
    setActiveTab(e);
  };

  useEffect(() => {
    let parentName = "";
    switch (activeTab) {
    case 0:
      parentName = "AdempimentiRiepilogoTotale";
      break;
    case 1:
      parentName = "AdempimentiContabilitaTotale";
      break;
    case 2:
      parentName = "AdempimentiRedditiTotale";
      break;
    case 3:
      parentName = "AdempimentiPagheTotale";
      break;
    case 4:
      parentName = "AdempimentiVersamentiTotale";
      break;
    case 5:
      parentName = "AdempimentiSostitutiTotale";
      break;
    case 6:
      parentName = "AdempimentiAltroTotale";
      break;
    default:
      break;
    }

    setActiveKpi(parentName);
  }, [activeTab]);

  const analytics = useSelector(state => state.analytics);

  const dataKpi =
    analytics && analytics.kpiList.status.ended ? analytics.kpiList.data : null;
  let graphs = [];
  let statistics = [];
  if (dataKpi && dataKpi.data) {
    for (let c = 0; c < dataKpi.data.length; c++) {
      let kpiCategories = dataKpi.data[c]["kpiScopes"];
      for (let d = 0; d < kpiCategories.length; d++) {
        if (kpiCategories[d].name !== "lynfa.std.studio.name") {
          continue;
        }

        kpiCategories[d].kpis.forEach(item => {
          if (item.url === "RicaviStudio" || item.url === "CreditiStudio") {
            return;
          }
          if (item.parentId === null) {
            statistics[item.url] = [];
            const obj = {
              idFather: item.id,
              kpiNameFather: item.url,
              children: []
            };
            graphs.push(obj);
          }
        });

        kpiCategories[d].kpis.forEach(item => {
          if (item.url === "RicaviStudio" || item.url === "CreditiStudio") {
            return;
          }
          if (item.parentId !== null) {
            const father = graphs.find(x => x.idFather === item.parentId);
            father.children.push({ kpiName: item.url });
            statistics[father.kpiNameFather].push(<AnalyticsChart
              idDivForChart={"analyticsView-chart" + item.url}
              fromObligations={true}
              kpiName={item.url}
              parentId={item.parentId}
              kpiType={item.kpiType.id}
            />);
          }
        });
      }
    }
  }

  const element = graphs.find(x => x.kpiNameFather === activeKpi);
  const children = element && element.children;

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
        <StandardTabs
          style={{ overflow: "hidden", width: "100%" }}
          activeIndex={activeTab}
          onChange={e => handleTabChange(e)}
          size="small"
        >
          <Tab key={0}>
            {" "}
            <FormattedMessage id="obligations.tabGeneral.title" />{" "}
          </Tab>
          <Tab key={1}>
            {" "}
            <FormattedMessage id="obligations.tabAccounting.title" />{" "}
          </Tab>
          <Tab key={2}>
            {" "}
            <FormattedMessage id="obligations.tabRevenues.title" />{" "}
          </Tab>
          <Tab key={3}>
            {" "}
            <FormattedMessage id="obligations.tabWages.title" />{" "}
          </Tab>
          <Tab key={4}>
            {" "}
            <FormattedMessage id="obligations.tabPayments.title" />{" "}
          </Tab>
          <Tab key={5}>
            {" "}
            <FormattedMessage id="obligations.tabSubstitute.title" />{" "}
          </Tab>
          <Tab key={6}>
            {" "}
            <FormattedMessage id="obligations.tabOther.title" />{" "}
          </Tab>
        </StandardTabs>
      </div>
      <div>
        <AnalyticsChart
          key={activeKpi}
          classChart=""
          idDivForChart={"analyticsObl-chart" + activeKpi}
          kpiName={activeKpi}
          childrenList={children ? children : null}
          fromObligations={true}
          kpiType={1}
        />
        {statistics[activeKpi]}
      </div>
    </React.Fragment>
  );
};

export default WidgetObligations;
